// @ts-check
import React from "react"

/**
 * @typedef {Object} UnitSuffixProps
 * @property {string} suffix
 * @property {boolean} [withSpace=true]
 */

/**
 * @param {UnitSuffixProps} props
 * @returns {JSX.Element}
 */
function UnitSuffix({ suffix, withSpace = true }) {
  return (
    <span className="cell-unit">
      {withSpace ? " " : ""}
      {suffix}
    </span>
  )
}

export default UnitSuffix
